import { Navbar, PricingCards, Footer } from '@/components/marketing';

export default function PricingPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="pt-24">
        <PricingCards />
      </div>
      <Footer />
    </div>
  );
}
